<div class="d-flex flex-row" style="cursor : pointer">
    <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-column mr-2">
            <h4 class="mb-0">You have received {{newLeadCount}} New Lead</h4>
        </div>
        <button class="ml-2 mr-2" (click)="closeNewLeadSnackBar()">Close</button>
        <button class="ml-auto" (click)="viewNewLeadsData()">View</button>
    </div>    
</div>